module.exports = __webpack_public_path__ + "static/media/18ECA26.6de5d8c7.jpg";